<template>
  <div :class="['fo-btn', { otherFoBtn: true }]" id="common-page-footer">
    <footer class="inner">
      <div class="linksBox">
        <!-- links 域 -->
        <div class="links">
          <dl>
            <dt>在线预定</dt>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/appoint?q=1'"
                target="_blank"
                >定制流程</a
              >
            </dd>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/pay?q=1'"
                target="_blank"
                >支付方式</a
              >
            </dd>
            <!-- <dd><a tag="a" to="/links/1.html" target="_blank">异地费，交通费标准</a></dd> -->
          </dl>
          <dl>
            <dt>消费保障</dt>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/service?q=1'"
                target="_blank"
                >实名认证</a
              >
            </dd>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/service?q=2'"
                target="_blank"
                >定金担保</a
              >
            </dd>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/service?q=3'"
                target="_blank"
                >价格透明</a
              >
            </dd>
          </dl>
          <dl>
            <dt>售后服务</dt>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/aftersale?q=1'"
                target="_blank"
                >无忧退款</a
              >
            </dd>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/aftersale?q=2'"
                target="_blank"
                >应急服务</a
              >
            </dd>
            <dd>
              <a
                tag="a"
                rel="nofollow"
                :href="WWW_URL + 'newzhaowo/aftersale?q=3'"
                target="_blank"
                >免费咨询</a
              >
            </dd>
          </dl>
        </div>
        <!-- / links 域 -->
        <!-- 二维码 -->
        <div class="erweima">
          <dl v-if="1 === 0">
            <dt>加入备婚群</dt>
            <dd>
              <img
                src="https://img.izhaowo.com/pc-wap/image/group-qrcode.png"
                alt=""
              />
            </dd>
          </dl>
          <span class="line" v-if="1 === 0 && showDown"></span>
          <!-- v-if="showDown" -->
          <dl class="down-app">
            <dt>下载APP</dt>
            <dd>
              <!-- <img src="../../assets/imgs/fixed-qr-1.png" alt="" /> -->
              <img
                src="https://img.izhaowo.com/pc-wap/image/new-down-app.png"
                alt=""
              />
            </dd>
          </dl>
          <dl>
            <dt>小程序</dt>
            <dd>
              <img
                src="https://img.izhaowo.com/pc-wap/image/new-ico-wechat.png"
                alt=""
              />
            </dd>
          </dl>
        </div>
        <!-- / 二维码 -->
      </div>
      <!-- 官网底部统一 -->
      <div class="classify" v-if="showType">
        <div class="flex-row">
          <div class="class-name">
            <a href="/case" class="title">婚礼案例</a>
          </div>
          <div class="flex-row" style="flex-wrap: wrap;">
            <template v-for="key in linkList.caseLinkList">
              <a :href="curlurl2P + key.link" class="tag-name">{{
                key.name
              }}</a>
            </template>
          </div>
        </div>

        <div class="flex-row">
          <div class="class-name">
            <a href="/worker" class="title">婚礼团队</a>
          </div>
          <div class="flex-row" style="flex-wrap: wrap;">
            <template v-for="key in linkList.workLinkList">
              <a :href="curlurl2P + key.link" class="tag-name">{{
                key.name
              }}</a>
            </template>
          </div>
        </div>

        <div class="flex-row">
          <div class="class-name">
            <a href="/hotel" class="title">婚礼酒店</a>
          </div>
          <div class="flex-row" style="flex-wrap: wrap;">
            <template v-for="key in linkList.hotelLinkList">
              <a :href="curlurl2P + key.link" class="tag-name">{{
                key.name
              }}</a>
            </template>
          </div>
        </div>

        <div class="flex-row">
          <div class="class-name">
            <a class="title">婚庆公司</a>
          </div>
          <div class="flex-row" style="flex-wrap: wrap;">
            <template v-for="key in linkList.hqLinkList">
              <a :href="curlurl2P + key.link" class="tag-name">{{
                key.name
              }}</a>
            </template>
          </div>
        </div>
      </div>

      <div class="copeRight">
        <div class="about fl">
          <p class="aboutUs">
            <!-- <a
              tag="a"
              target="_blank"
              rel="nofollow"
              :href="curlurl2P + '/ourStory/progress'"
              >关于找我</a
            > -->
            <a
              tag="a"
              target="_blank"
              rel="nofollow"
              :href="curlurl2P + '/newzhaowo/contact'"
              >联系找我</a
            >
            <!-- <a tag="a" target="_blank" rel="nofollow" :href="curlurl2+'about/join.html'">加入找我</a> -->
            <a
              tag="a"
              target="_blank"
              rel="nofollow"
              :href="curlurl2P + '/newzhaowo/falv'"
              >法律声明</a
            >
            <a target="_blank" rel="nofollow" :href="curlurl2">快速定制</a>
            <!-- <a
              tag="a"
              target="_blank"
              rel="nofollow"
              href="https://www.izhaowo.com/cityPartner"
              >招募城市合伙人</a
            > -->
            <a
              tag="a"
              target="_blank"
              rel="nofollow"
              href="https://www.izhaowo.com/workerRecruit"
              >招募婚礼人</a
            >
          </p>
          <p class="copeRight" style="min-width: 600px;">
            <span class="qianhui">增值电信业务经营许可证：</span>
            <span class="shenhui">川B2-20140181</span>
            <i class="qianhui">|</i>
            <span class="qianhui">© {{ nowYear }} izhaowo.com </span>
            <a class="shenhui" href="https://beian.miit.gov.cn" target="_blank"
              >蜀ICP备14014073号-1</a
            >
            <!--<i class="qianhui">|</i>-->
          </p>
          <p class="copeRight" style="margin-top: 22px;">
            <span class="qianhui">成都爱找我科技有限公司</span>
            <!-- <i class="qianhui">|</i>
            <span class="qianhui">联系电话： </span>
            <span class="shenhui">028-81472090</span> -->
          </p>
        </div>

        <div class="tel fr" style="margin-bottom: 50px;">
          <p class="info">客服热线（周一至周日9:00 - 18:30）</p>
          <p class="phone">4000-119-139</p>
          <!-- <p class="text">售前咨询·售后处理·投诉反馈</p> -->
        </div>

        <div class="fr wechat">
          <div class="open-wx" v-show="isWX">
            <img src="https://img.izhaowo.com/pc-wap/image/login_weixin3.png" />
          </div>

          <img
            src="../../assets/images/login_weixin-v2.png"
            class="cup"
            style="margin-right: 12px;"
            @mouseover="setIsWX(true)"
            @mouseleave="setIsWX(false)"
          />

          <a href="https://weibo.com/izhaowo?is_hot=1" target="_blank">
            <img class="cup" src="../../assets/images/login_wb-v2.png" />
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import api from "../../config/api.js";
// const caseLinkList = [
//   { name: "草坪婚礼", link: "/case/b1" },
//   { name: "教堂婚礼", link: "/case/b2" },
//   { name: "户外婚礼", link: "/case/b3" },
//   { name: "室内婚礼", link: "/case/b4" },
//   { name: "复古婚礼", link: "/case/c1" },
//   { name: "梦幻婚礼", link: "/case/c2" },
//   { name: "大气婚礼", link: "/case/c3" },
//   { name: "主题婚礼", link: "/case/c4" },
//   { name: "简洁婚礼", link: "/case/c5" },
//   { name: "新中式婚礼", link: "/case/c6" },
//   { name: "小清新婚礼", link: "/case/c7" },
//   { name: "唯美婚礼", link: "/case/c8" },
//   { name: "韩式婚礼", link: "/case/c9" },
//   { name: "森系婚礼", link: "/case/c10" },
//   { name: "西式婚礼", link: "/case/c11" },
//   { name: "传统中式婚礼", link: "/case/c12" },
// ];

const workLinkList = [
  { name: "婚礼策划师", link: "/worker/b0" },
  { name: "婚礼化妆师", link: "/worker/b1" },
  { name: "婚礼主持人", link: "/worker/b2" },
  { name: "婚礼摄影师", link: "/worker/b3" },
  { name: "婚礼摄像师", link: "/worker/b4" },
  { name: '婚礼统筹师', link: '/planner' }
];

// const hotelLinkList = [
//   { name: "成都婚宴酒店", link: "/hotel/a1_b1" },
//   { name: "南昌婚宴酒店", link: "/hotel/a2_b1" },
//   { name: "重庆婚宴酒店", link: "/hotel/a3" },
// ];

// const hqLinkList = [
//   { name: "成都婚庆公司", link: "/chengdu/hq" },
//   { name: "重庆婚庆公司", link: "/chongqing/hq" },
//   { name: "南昌婚庆公司", link: "/nanchang/hq" },
//   { name: "南充婚庆公司", link: "/nanchong/hq" },
//   { name: "乐山婚庆公司", link: "/leshan/hq" },
//   { name: "巴中婚庆公司", link: "/bazhong/hq" },
//   { name: "德阳婚庆公司", link: "/deyang/hq" },
//   { name: "西安婚庆公司", link: "/xian/hq" },
//   { name: "贵阳婚庆公司", link: "/guiyang/hq" },
// ];

export default {
  data() {
    return {
      curlurl2P: api.WWW_IZHAOWO_URL,
      curlurl2: "/",
      nowYear: new Date().getFullYear(),
      WWW_URL: api.WWW_IZHAOWO_URL + "/",
      isWX: false,
      isStrategy: false,
      showType: true,
      showDown: true,
      linkList: {
        caseLinkList: [],
        workLinkList,
        hotelLinkList: [],
        hqLinkList: []
      }
    };
  },
  methods: {
    setIsWX: function (type) {
      this.isWX = type;
    },
    getStyleList() {
      let vm = this;
      vm.getAjax(
        `${api.API_URL}production/v1/query/case/parameter`,
        {},
        function (res) {
          try {
            let optionDatas = res.rdata
            if (optionDatas) {
              if (optionDatas.sceneList && optionDatas.sceneList.length > 0)
                optionDatas.sceneList.forEach((item, index) => {
                  vm.linkList.caseLinkList.push({
                    name: item.name + '婚礼',
                    link: '/case/b' + (index + 1)
                  })
                })
              if (optionDatas.styleList && optionDatas.styleList.length > 0)
                optionDatas.styleList.forEach((item, index) => {
                  vm.linkList.caseLinkList.push({
                    name: item.name + '婚礼',
                    link: '/case/c' + (index + 1)
                  })
                })
            }
          } catch (e) {
            console.log(e)
          }
        },
        function () {
          vm.$message.error("网络连接异常，请稍后重试");
        }
      );
    },
    getHotelList() {
      let vm = this;
      vm.getAjax(
        `${api.CMS_URL}v1/hotel/location/group/province`,
        {},
        function (res) {
          try {
            let optionDatas = res.rdata;
            if (optionDatas && optionDatas.length > 0) {
              optionDatas.forEach((item, index) => {
                if (['重庆市', '上海市', '天津市', '北京市'].includes(item.provinceName)) {
                  let tempName = item.provinceName.replace('市', '')
                  vm.linkList.hotelLinkList.push({
                    name: tempName + '婚宴酒店',
                    link: '/hotel/a' + (index + 1)
                  })
                } else if (item.citys && item.citys.length > 0) {
                  item.citys.forEach((cityInfo, j) => {
                    let tempName = cityInfo.name.replace('市', '')
                    vm.linkList.hotelLinkList.push({
                      name: tempName + '婚宴酒店',
                      link: '/hotel/a' + (index + 1) + '_b' + (j + 1)
                    })
                  })
                }
              })
            }
          } catch (e) {
            console.log(e)
          }
        },
        function () {
          vm.$message.error("网络连接异常，请稍后重试");
        }
      );
    },
    async getHqList() {
      try {
        let proList = localStorage.getItem('web_pro_list')
        if (!proList) {
          // 请求接口
          let result = await this.queryProvince()
          if (result && result.length > 0) {
            proList = result.slice(1)
          }
        } else {
          proList = JSON.parse(proList)
        }
        if (proList && proList.length > 0) {
          proList.forEach((item, index) => {
            if (['重庆市', '上海市', '天津市', '北京市'].includes(item.label)) {
              let tempName = item.label.replace('市', '')
              this.linkList.hqLinkList.push({
                name: tempName + '婚庆公司',
                link: item.provincialCapitalEn + '/hq'
              })
            } else if (item.citys && item.citys.length > 0) {
              item.citys.forEach((cityInfo, j) => {
                if (cityInfo) {
                  let tempName = cityInfo.name.replace('市', '')
                  let spell = cityInfo.spell.replace(' ', '')
                  this.linkList.hqLinkList.push({
                    name: tempName + '婚庆公司',
                    link: '/' + spell.toLowerCase() + '/hq'
                  })
                }
              })
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async queryProvince() {
      let result = [];
      let list = [];
      let url = api.TOP_URL + "app-api/province/v1/query/list";
      let all_city = [];
      let vm = this;
      vm.getAjax(
        url,
        "",
        function (recomData) {
          if (recomData && recomData.rcode === "000000") {
            result = recomData.rdata;
            for (let i in result) {
              // console.log('tag', i)
              let item = {}
              item.value = result[i].province
              item.label = result[i].province
              item.province_id = result[i].provinceId
              item.provincialCapitalEn = '/' + result[i].provincialCapitalEn
              item.index = parseInt(i) + 1
              item.citys = result[i].citys
              if (result[i].province === '重庆市' || result[i].province === '天津市' || result[i].province === '上海市' || result[i].province === '北京市') {
                  item.citys.push({
                      name: result[i].province
                  })
              }
              list.push(item)
                  //全国显示所有城市
              result[i] && result[i].citys ? all_city.push(...result[i].citys) : ''
            }
            //省份中没有返回全国字段 需要自己拼接
            list.unshift({
              value: '',
              label: '全国',
              province_id: '',
              index: 0,
              provincialCapitalEn: '/',
              citys: all_city,
              province: '全国'
            }, )
            list && list.length > 0 && localStorage.setItem('web_pro_list', JSON.stringify(list.slice(1)))
            return list
          }
        },
        function () {}
      );
    },
  },
  async mounted() {
    await this.getStyleList() // 获取风格之类的
    await this.getHotelList() // 获取酒店之类的
    await this.getHqList() // 获取开通城市之类的
    console.log("🚀 ~ mounted ~ linkList:", this.linkList)
    console.log("route", this.$route);
  },
};
</script>

<style scoped="">
.inner {
  width: 1224px;
}
.fo-btn {
  background: #f7f7f7;
  width: 100%;
  position: relative;
}
.otherFoBtn {
  background: #ffffff !important;
}

footer {
  /* padding: 100px 0 15px 0; */
  padding: 50px 0 15px 0;
  margin: 0 auto;
}
footer .linksBox {
  /* padding-top: 30px; */
  width: 100%;
  height: 173px;
  border-bottom: 1px solid #e1e1e1;
  margin-bottom: 40px;
}
footer .linksBox .links {
  float: left;
}
footer .linksBox .links dl,
footer .linksBox .erweima dl {
  float: left;
}
footer .linksBox .erweima .line {
  float: left;
  margin-left: 45px;
  margin-top: 37px;
  height: 74px;
  border-right: 1px dashed #dadada;
}
footer .linksBox .links dl {
  margin-right: 40px;
  width: 120px;
  line-height: 17px;
}
footer .linksBox dl dt {
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.9);
}
footer .linksBox .links dl dt {
  font-weight: 600;
}
footer .linksBox .links dl dd {
  margin-bottom: 10px;
}
footer .linksBox .links dl dd a {
  font-size: 12px;
  color: rgba(71, 71, 71, 0.9);
}
footer .linksBox .erweima {
  float: right;
}
footer .linksBox .erweima dl {
  width: 100px;
  margin-left: 54px;
}
footer .linksBox .erweima dl.down-app {
  margin-left: 45px;
}
footer .linksBox .erweima dl dt {
  text-align: center;
}
footer .linksBox .erweima dl dd img {
  width: 100px;
  height: 100px;
}
div.copeRight {
  /*overflow: hidden;*/
  height: 160px;
}
div.copeRight span {
  font-size: 13px;
}
div.copeRight .aboutUs {
  margin-bottom: 20px;
}
div.copeRight .aboutUs a {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.9);
  font-weight: 500;
  margin-right: 50px;
  line-height: 17px;
}
div.copeRight .copeRight {
  line-height: 18px;
  color: rgba(0, 0, 0, 0.9);
}
div.copeRight .copeRight i {
  color: #979797;
  margin: 0 15px;
}
.tel {
  width: 248px;
}
.tel .info {
  font-size: 12px;
  line-height: 17px;
  color: #979797;
  font-family: PingFangSC-Regular;
}
.tel .phone {
  line-height: 37px;
  font-size: 26px;
  color: rgba(0, 0, 0, 0.9);
  margin-top: 10px;
}
.tel .text {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #979797;
}
.wechat {
  padding-top: 76px;
  position: relative;
  right: -53px;
}

.wechat img {
  width: 18px;
  height: 18px;
}

.open-wx {
  position: absolute;
  box-shadow: 0 3px 20px 0 rgba(153, 153, 153, 0.5);
  bottom: 60px;
  left: -35px;
  width: 110px;
  height: 110px;
}

.open-wx img {
  width: 110px;
  height: 110px;
}

.classify {
  /* height: 228px; */
  padding-bottom: 1px;
  border-bottom: 1px solid #e1e1e1;
  margin-bottom: 40px;
}

.classify .title {
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.9);
}

.classify > div {
  margin-bottom: 10px;
}

.classify a {
  display: inline-block;
  flex-shrink: 0;
  flex-grow: 0;
  font-size: 12px !important;
  color: rgba(117, 124, 147, 0.7);
}

.classify .class-name a {
  font-size: 16px;
  line-height: 22px;
  width: 110px;
  margin-right: 5px;
}

.classify .tag-name {
  font-size: 16px;
  line-height: 22px;
  min-width: 98px;
  margin-right: 2px;
  margin-bottom: 12px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
</style>



// WEBPACK FOOTER //
// foot-bar-new.vue?a9d2317e